import React, { useState, useCallback } from "react";
import "@/App.css";
import { FlipBook } from "@/components/FlipBook";
import { LoadingScreen } from "@/components/LoadingScreen";
import { ThemeProvider } from "@/components/ThemeProvider";

function App() {
  const [loading, setLoading] = useState(true);
  const [showcases, setShowcases] = useState([]);
  const [categories, setCategories] = useState([]);

  const handleLoadComplete = useCallback((showcasesData, categoriesData) => {
    setShowcases(showcasesData);
    setCategories(categoriesData || []);
    setLoading(false);
  }, []);

  return (
    <ThemeProvider>
      {loading && <LoadingScreen onComplete={handleLoadComplete} />}
      {!loading && <FlipBook showcases={showcases} categories={categories} />}
    </ThemeProvider>
  );
}

export default App;
